import React from 'react';
import EInvoiceAccessLayout from '../../../components/EInvoiceAccessLayout';
import { READ_BUSINESS_PROFILE } from '../../../constants/eInvoicePermissions';

export default function BusinessProfileAccessLayout() {

  return (
    <EInvoiceAccessLayout permission={READ_BUSINESS_PROFILE} title={'Business Profiles'} />
  );
}
